module.exports = __webpack_public_path__ + "img/icon_dean_home_alert_icon_10.57383a03.png";